import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { PassportLogo } from "@/components/Reveal";
import { useTranslation } from "react-i18next";

export default function Terms() {
    const { t } = useTranslation();
    const sections = t("terms.sections", { returnObjects: true }) || [];

    return (
        <div className="min-h-screen grain" data-testid="terms-page">
            <div className="max-w-3xl mx-auto px-6 md:px-10 py-12">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-[color:var(--gold)] mb-12" data-testid="terms-back">
                    <ArrowLeft size={14} /> {t("terms.backToPassport")}
                </Link>

                <div className="flex items-center gap-3 mb-8">
                    <PassportLogo size={44} />
                    <div>
                        <div className="overline">{t("conciergeApp.passport")}</div>
                        <div className="font-serif text-lg text-white">{t("terms.theSocialTravelNetwork")}</div>
                    </div>
                </div>

                <div className="overline mb-4">{t("terms.legalOverline")}</div>
                <h1 className="font-serif text-5xl md:text-6xl text-white tracking-tighter leading-[0.95] mb-14">{t("terms.title")}</h1>

                <div className="space-y-10">
                    {Array.isArray(sections) && sections.map((s, idx) => (
                        <section key={idx}>
                            <h2 className="font-serif text-2xl text-white mb-3">{s.h}</h2>
                            <p className="text-white/70 leading-relaxed">{s.b}</p>
                        </section>
                    ))}
                </div>

                <div className="mt-16 pt-8 border-t flex flex-wrap items-center justify-between gap-4" style={{ borderColor: "rgba(255,255,255,0.08)" }}>
                    <div className="text-sm text-white/50">{t("terms.lastUpdated")} <span className="text-[color:var(--gold)]">{t("terms.lastUpdatedDate")}</span></div>
                    <Link to="/privacy" className="text-sm text-white/70 hover:text-[color:var(--gold)]">{t("terms.privacyPolicy")}</Link>
                </div>
            </div>
        </div>
    );
}
